// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html




// AbilityIntranet.Data.Intranet.QbModels.QbTxnType
export enum QbTxnType {
    
    Unknown = 0,
    ARRefundCreditCard = 1,
    Bill = 2,
    BillPaymentCheck = 3,
    BillPaymentCreditCard = 4,
    BuildAssembly = 5,
    Charge = 6,
    Check = 7,
    CreditCardCharge = 8,
    CreditCardCredit = 9,
    CreditMemo = 10,
    Deposit = 11,
    Estimate = 12,
    InventoryAdjustment = 13,
    Invoice = 14,
    ItemReceipt = 15,
    JournalEntry = 16,
    LiabilityAdjustment = 17,
    Paycheck = 18,
    PayrollLiabilityCheck = 19,
    PurchaseOrder = 20,
    ReceivePayment = 21,
    SalesOrder = 22,
    SalesReceipt = 23,
    SalesTaxPaymentCheck = 24,
    Transfer = 25,
    VendorCredit = 26,
    YTDAdjustment = 27,
    TransferInventory = 28
}
